import { useGlobalSettingsContext, getGlobalSetting_UNSAFE } from 'contexts/GlobalSettingsContext';
import { VOCABULARY_STATUS } from 'views/Findings/constants/status';
import _, { isFunction, isNumber } from 'lodash'
import React from 'react';

export const getVocabulary = (name, isPlural = false) => {
    const globalSettings = getGlobalSetting_UNSAFE();
    const buTitle = globalSettings.bu?.[`${name}Name`]
    if(!_.isUndefined(buTitle) && !_.isEmpty(buTitle)){
        return isPlural ? getPluralName(buTitle) : buTitle;
    }
    const settingName = globalSettings[name] || globalSettings[name?.toLowerCase()] || name;
    return isPlural ? getPluralName(settingName) : settingName;
}

const Vocabulary = React.memo(function Vocabulary({ name, isLowerCase = false, allUpper = false, isPlural = false, isNoun, ...props }) {
    const globalSettings = useGlobalSettingsContext();
    const buTitle = globalSettings.bu?.[`${name}Name`]
    let title;
    if(!_.isUndefined(buTitle) && !_.isEmpty(buTitle)){
        title = buTitle
    }
    else{
        title = isLowerCase ? (globalSettings[name]).toLowerCase() : globalSettings[name];
    }
    if(!title) {
        return name;
    }
    if(VOCABULARY_STATUS.includes(name)){
        if(isNoun){
            return `${title.slice(0, -2)}ion`
        }
        return title
    }
    if (allUpper) {
        title = _.toUpper(title);
    }
    if(isPlural === true){
       return getPluralName(title)
    }
    if(isPlural === false){
        if(title.endsWith('ies')){
            return `${title.slice(0,-3)}y`
        }
        else if(title.endsWith('s') && !title.endsWith('ss')){
            return title.slice(0,-1)
        }
        else{
            return title;
        }
    }
});

export default Vocabulary;

export const getInnerText = (reactElem) => {
    if (_.isString(reactElem) || isNumber(reactElem)) {
        return `${reactElem}`;
    }

    if(!reactElem.props && isFunction(reactElem.reduce)){ /** When element contain plain text with some tag eg. Cross <br> site. which is not React Element */
        return reactElem.reduce((text, children) => {
            return text + getInnerText(children);
        }, '').trim();
    }
    if (!reactElem.props.children) {
        const { name } = reactElem.props;
        if(reactElem.props?.isPlural){
            return getPluralName(getVocabulary(name))
        }
        return getVocabulary(name) || name || '';
    }
    if (_.isArray(reactElem.props.children)) {
        return reactElem.props.children.reduce((text, children) => {
            return text + getInnerText(children);
        }, '').trim();
    }
    return getInnerText(reactElem.props.children);
};

const getPluralName = (title) => {
    if(title.endsWith('s')){
        return title
    }
    else if(title.endsWith('y')){
        return `${title.slice(0,-1)}ies`
    }
    else{
        return `${title}s`
    }
}

